const routes = [
    {
        path: "/certificate/application",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "certificateapplication_index"
        }
    },
    {
        path: "/certificate/payments/report",
        component: () => import("../pages/PaymentReport.vue"),
        meta: {
            isAuthenticated: true,
            permission: "certificatepayment_report"
        }
    },

];

export default routes;
